import { Link } from "react-router-dom"
import styled from "styled-components"

import { MOBILE_NAV_Z_INDEX_CONTENT } from "components/common/VerticalMenu/styled"

export const MOBILE_BREAKPOINT = "768px"

export const RightSideIconsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  gap: 2px;
`

export const LeftSideWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  z-index: ${MOBILE_NAV_Z_INDEX_CONTENT};
`

export const MenuToggleButton = styled.button<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  svg {
    width: 20px;
    height: 20px;
    fill: #f8fafc;
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    transform: ${({ $isOpen }) => ($isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: none;
  }
`

export const HamburgerWrapper = styled.div`
  display: none;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: flex;
  }
`

export const LogoWrapper = styled(Link)`
  align-self: baseline;
  min-width: 100px;
  transition: margin-left 0.25s cubic-bezier(0.4, 0, 0.2, 1);
`

export const StyledLogo = styled.img`
  min-height: 64px;
  max-height: 80px;
  object-fit: contain;
`
